<template>
  <div class="navbar-desktop" :class="{ proposed }">
    <router-link :to="{ name: 'Home' }" class="logo">
      <img v-if="companiesConfig.logo" :onload="(imgReady = true)" :src="imgDataUrl" />
    </router-link>
    <template v-if="proposed">
      <img src="~/assets/img/pdf/img1.jpg" alt="" style="height: 90px" />
    </template>
    <div class="right" v-else :class="{ fullHeight: company }">
      <div v-if="company" class="company f14">
        <div class="company_name">
          {{ companiesConfig.company_name }}
        </div>
        <div class="company_address">
          {{ companiesConfig.registration_address }}
        </div>
      </div>
      <div v-else class="date f14">
        {{ new Date().toLocaleDateString() }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderPdf',
  components: {},
  props: { company: Boolean, proposed: Boolean },
  data: () => ({
    imgDataUrl: null,
    imgReady: false,
  }),
  computed: {
    ...mapGetters(['companiesConfig']),
    userData() {
      return this.$store.getters['user/userData']
    },
  },
  created() {
    this.getImg()
  },
  watch: {
    companiesConfig() {
      this.getImg()
    },
    imgReady() {
      this.$emit('imgReady', this.imgReady)
    },
  },
  methods: {
    getImg() {
      if (this.companiesConfig && this.companiesConfig.logo) {
        let url = this.companiesConfig.logo['svg']
        this.$axios
          .get(url, { responseType: 'arraybuffer' })
          .then(
            (response) =>
              (this.imgDataUrl = `data:${response.headers['content-type']};base64,${btoa(
                String.fromCharCode(...new Uint8Array(response.data)),
              )}`),
          )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-desktop {
  // width: 100%;
  height: 120px;
  background: #ffffff;
  border-bottom: #b4b4b4 1px solid;
  padding: 10px 30px;
  display: grid;
  grid-template-columns: max-content auto;
  grid-column-gap: 30px;
  justify-content: space-between;
  align-items: center;
  &.proposed {
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: grid;
    align-content: center;
    height: 100%;
    img {
      max-height: 100px;
      width: 100%;
      height: auto;
      max-width: 250px;
    }
  }

  .right {
    &.fullHeight {
      height: 100%;
    }
    .date {
      color: #333333;
      font-weight: normal;
    }
    .company {
      height: 100%;
      color: #333333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 200px;
      &_address {
        margin-top: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>
